export default "__VITE_ASSET__DeEvPHdS__"